import { createContext, useContext, useState } from "react";

const RightSidebarContext = createContext(null);

export const RightSidebarProvider = ({ children }) => {
  const [isRightOpen, setIsRightOpen] = useState(false);
  const [rightComponent, setRightComponent] = useState(null);
  const [rightSidebarMode, setRightSidebarMode] = useState(null);
  const [rightId, setRightId] = useState(null);

  return (
    <RightSidebarContext.Provider
      value={{
        isRightOpen,
        setIsRightOpen,
        rightComponent,
        setRightComponent,
        rightSidebarMode,
        setRightSidebarMode,
        rightId,
        setRightId,
      }}
    >
      {children}
    </RightSidebarContext.Provider>
  );
};

export const useRightSidebar = () => {
  const ctx = useContext(RightSidebarContext);
  if (!ctx)
    throw new Error("useRightSidebar must be used within RightSidebarProvider");
  return ctx;
};

export default RightSidebarContext;
